import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  showArrow?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  showArrow = false,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center gap-3 px-8 py-4 text-lg font-medium transition-all duration-300 rounded-full overflow-hidden group';
  const variants = {
    primary: 'bg-burgundy-600 text-white shadow-premium hover:shadow-premium-hover hover:bg-burgundy-700',
    outline: 'bg-transparent border-2 border-burgundy-200 text-burgundy-700 hover:border-burgundy-600 hover:bg-burgundy-50'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-13">
      <span className="relative z-10 flex items-center gap-2" data-id="element-14">
        {children}
        {showArrow && <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-15" />}
      </span>
      {variant === 'primary' && <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-16" />}
    </motion.button>;
}